import DocumentComponents from "./DocumentComponents";

export default DocumentComponents;



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/index.js